import { useState, type ReactElement } from 'react';
import { Box, useTranslation } from '@common';
import * as Base from '@base';
import { service } from '../service';
import styles from '../style.module.less';
import { DragItem, Highlighter } from '../../component';
import { usePrimaryColor } from '../../hooks';
import type dayjs from 'dayjs';
import type { CalendarProps } from './types';

export function CalendarDesignMode(props: CalendarProps): ReactElement {
  const [t] = useTranslation();
  const { rgbColor } = usePrimaryColor();
  const [date, setData] = useState<dayjs.Dayjs | null | undefined>(undefined);

  // 拖拽时显示组件
  if (props.name == null) {
    return (
      <DragItem title={t('Calendar')} />
    );
  }

  // 主题色
  const activeStyle = props.active === true ? {
    boxShadow: `${rgbColor} 0 0 3px`
  } : {};
  return (
    <Box
      className={styles.designBox}
      style={{ ...activeStyle, paddingLeft: service.getIndent(props.path) }}>
      <Box className={styles.subject}>
        <Highlighter
          title={props.title}
          keyword={props.keyword}
          className={styles.title}
          require={props.validator === 'required'}
        />
      </Box>
      <Box className={styles.input}>
        <Base.DatePicker
          className={styles.datePicker}
          value={date}
          inputReadOnly={props.readonly === true}
          onChange={value => setData(value)}
          placeholder={props.textPlaceholder ?? ''}
        />
      </Box>
    </Box>
  );
}
